import React from 'react';

import { PageContext } from '../../../../../contexts/ContextCreator';

import IconTitleItemLayout from '../../Layout/IconTitleItemLayout/IconTitleItemLayout';
import { Counter } from '../../Modules/Counter/Counter';
import UserDropdown from '../../Modules/Dropdowns/UserDropdown/UserDropdown';
import VerticalLine from '../../Modules/NavbarItems/VerticalLine/VerticalLine';
import WideFgbLogo from '../../Modules/NavbarItems/WideFgbLogo/WideFgbLogo';
import Hamburger from '../../Modules/NavbarItems/Hamburger/Hamburger';
import SearchForm from '../../Modules/SearchForm/SearchForm';

export default [
    {
        metaData: {
            key: 'hamburger',
            title: null,
            url: null,
            imgSrc: '576004112/navbar/hamburger-w.svg',
            metricEvent: 'mobile-hamburger-click',
            position: 'top',
            className: 'hamburger',
        },
        Component: ({ metaData, setActionState, handleMetricEvent }) => (
            <Hamburger
                metaData={metaData}
                setActionState={setActionState}
                handleMetricEvent={handleMetricEvent}
            />
        ),
    },

    {
        metaData: {
            key: 'wide-fgb-logo',
            title: null,
            url: '/community/feed',
            imgSrc: '576004259/navbar/wide_logo.svg',
            metricEvent: null,
            position: 'top',
            className: 'wide-fgb-logo',
        },
        Component: ({ metaData }) => <WideFgbLogo {...metaData} />,
    },

    {
        metaData: {
            key: 'search-form',
            title: null,
            url: null,
            imgSrc: null,
            metricEvent: null,
            position: 'top',
            className: 'search-form',
        },
        Component: ({ metaData: { className }, isLoggedIn, notifications }) => {
            const isAlertShown =
                isLoggedIn || (notifications && notifications.unseenCount > 0);
            const newClassName = `${className} ${
                isAlertShown ? '' : 'search-form--full-width'
            }`;

            return <SearchForm className={newClassName} />;
        },
    },

    {
        metaData: {
            key: 'alert-left',
            title: null,
            url: '/users/notifications',
            imgSrc: '576251212/navbar/notification-w.svg',
            metricEvent: 'top-nav-alerts-click',
            position: 'top',
            className: 'alert-left',
        },
        Component: ({
            metaData,
            handleMetricEvent,
            isLoggedIn,
            notifications,
        }) => {
            const isAlertShown =
                isLoggedIn || (notifications && notifications.unseenCount > 0);

            return (
                isAlertShown && (
                    <IconTitleItemLayout
                        itemKey={metaData.key}
                        className={metaData.className}
                        url={metaData.url}
                        title={metaData.title}
                        imgSrc={metaData.imgSrc}
                        handleClick={handleMetricEvent(metaData.metricEvent)}
                    >
                        {!!notifications.unseenCount && (
                            <Counter
                                cssClass="header-badges header-badges--alert-badge header-badges--alert-left"
                                countNumber={notifications.unseenCount}
                            />
                        )}
                    </IconTitleItemLayout>
                )
            );
        },
    },

    {
        metaData: {
            key: 'home',
            title: 'Home',
            url: '/community/feed',
            imgSrc: '576251953/navbar/home-icon.svg',
            metricEvent: 'top-nav-home-click',
            position: 'bottom',
            className: 'home',
        },
        Component: ({ metaData, handleMetricEvent, badgeCountData }) => (
            <IconTitleItemLayout
                itemKey={metaData.key}
                className={metaData.className}
                url={metaData.url}
                title={metaData.title}
                imgSrc={metaData.imgSrc}
                handleClick={handleMetricEvent(metaData.metricEvent)}
            >
                {badgeCountData && badgeCountData.newFeedItems && (
                    <Counter
                        cssClass="header-badges"
                        countNumber="*"
                        type="star"
                    />
                )}
            </IconTitleItemLayout>
        ),
    },

    {
        metaData: {
            key: 'jobs',
            title: 'Jobs',
            url: '/jobs/filter',
            imgSrc: '576252193/navbar/jobs-w.svg',
            metricEvent: 'top-nav-jobs-click',
            position: 'bottom',
            className: 'jobs',
        },
        Component: ({ metaData, handleMetricEvent, badgeCountData }) => (
            <IconTitleItemLayout
                itemKey={metaData.key}
                className={metaData.className}
                url={metaData.url}
                title={metaData.title}
                imgSrc={metaData.imgSrc}
                handleClick={handleMetricEvent(metaData.metricEvent)}
            >
                {badgeCountData && !!badgeCountData.newJobs && (
                    <Counter
                        cssClass="header-badges"
                        countNumber={badgeCountData.newJobs}
                    />
                )}
            </IconTitleItemLayout>
        ),
    },

    {
        metaData: {
            key: 'reviews',
            title: 'Reviews',
            url: '/company-reviews',
            imgSrc: '576257514/navbar/reviews-w.svg',
            metricEvent: 'top-nav-reviews-click',
            position: 'bottom',
            className: 'reviews',
        },
        Component: ({ metaData, handleMetricEvent }) => (
            <IconTitleItemLayout
                itemKey={metaData.key}
                className={metaData.className}
                url={metaData.url}
                title={metaData.title}
                imgSrc={metaData.imgSrc}
                handleClick={handleMetricEvent(metaData.metricEvent)}
            />
        ),
    },

    {
        metaData: {
            key: 'network',
            title: 'Network',
            url: '/users/connections',
            imgSrc: '576252554/navbar/network-w.svg',
            metricEvent: 'top-nav-network-click',
            position: 'bottom',
            className: 'network',
        },
        Component: ({ metaData, handleMetricEvent, badgeCountData }) => (
            <IconTitleItemLayout
                itemKey={metaData.key}
                className={metaData.className}
                url={metaData.url}
                title={metaData.title}
                imgSrc={metaData.imgSrc}
                handleClick={handleMetricEvent(metaData.metricEvent)}
            >
                {badgeCountData && !!badgeCountData.pendingConnections && (
                    <Counter
                        cssClass="header-badges"
                        countNumber={badgeCountData.pendingConnections}
                    />
                )}
            </IconTitleItemLayout>
        ),
    },

    {
        metaData: {
            key: 'resources',
            title: 'Resources',
            url: '/resources',
            imgSrc: '576257205/navbar/resource-w.svg',
            metricEvent: 'top-nav-resources-click',
            position: 'bottom',
            className: 'resources',
        },
        Component: ({
            metaData,
            handleMetricEvent,
            athorizedForEmployerNav,
            viewWidth,
        }) => {
            if (athorizedForEmployerNav && viewWidth < 992) {
                return null;
            }

            return (
                <IconTitleItemLayout
                    itemKey={metaData.key}
                    className={metaData.className}
                    url={metaData.url}
                    title={metaData.title}
                    imgSrc={metaData.imgSrc}
                    handleClick={handleMetricEvent(metaData.metricEvent)}
                />
            );
        },
    },

    {
        metaData: {
            key: 'for-clients-left',
            title: 'For Clients',
            url: '/employers/database',
            imgSrc: '575995136/navbar/employer-w.svg',
            metricEvent: 'top-nav-for-clients-click',
            position: 'bottom',
            className: 'for-clients-left',
        },
        Component: ({
            metaData,
            handleMetricEvent,
            athorizedForEmployerNav,
        }) => {
            if (!athorizedForEmployerNav) {
                return null;
            }

            return (
                <IconTitleItemLayout
                    itemKey={metaData.key}
                    className={metaData.className}
                    url={'/employers/dashboard'}
                    title={metaData.title}
                    imgSrc={metaData.imgSrc}
                    handleClick={handleMetricEvent(metaData.metricEvent)}
                />
            );
        },
    },

    {
        metaData: {
            key: 'alert-right',
            title: 'Alerts',
            url: '/users/notifications',
            imgSrc: '576251212/navbar/notification-w.svg',
            metricEvent: 'top-nav-alerts-click',
            position: 'bottom',
            className: 'alert-right',
        },
        Component: ({
            metaData,
            handleMetricEvent,
            isLoggedIn,
            notifications,
        }) => {
            const shouldShowAlert =
                isLoggedIn || (notifications && notifications.unseenCount > 0);

            return (
                shouldShowAlert && (
                    <IconTitleItemLayout
                        itemKey={metaData.key}
                        className={metaData.className}
                        url={metaData.url}
                        title={metaData.title}
                        imgSrc={metaData.imgSrc}
                        handleClick={handleMetricEvent(metaData.metricEvent)}
                    >
                        <React.Fragment>
                            {!!notifications.unseenCount && (
                                <Counter
                                    cssClass="header-badges header-badges--alert-badge"
                                    countNumber={notifications.unseenCount}
                                />
                            )}
                        </React.Fragment>
                    </IconTitleItemLayout>
                )
            );
        },
    },

    {
        metaData: {
            key: 'user-auth',
            title: 'Me',
            imgSrc: '/v1/avatar_black_160_vtg7lw.svg',
            url: null,
            metricEvent: 'top-nav-me-click',
            position: 'bottom',
            className: 'user-auth',
        },
        Component: ({
            metaData,
            setActionState,
            getActionState,
            handleMetricEvent,
            viewWidth,
            userDropdownProps,
            userImgSrc,
            badgeCountData,
            isLoggedIn,
        }) => {
            if (!isLoggedIn) return null;

            const { pendingConnections, unreadMessageCount } = badgeCountData;
            const totalCount = pendingConnections + unreadMessageCount;
            const handleClick = () => {
                const actionState =
                    viewWidth > 992 ? 'isUserDropdownOpen' : 'isUserDrawerOpen';
                return setActionState(
                    actionState,
                    !getActionState(actionState),
                    getActionState(actionState) === false
                        ? handleMetricEvent(metaData.metricEvent)
                        : () => {}
                );
            };

            return (
                <IconTitleItemLayout
                    itemKey={metaData.key}
                    className={metaData.className}
                    url={metaData.url}
                    title={metaData.title}
                    imgSrc={userImgSrc || metaData.imgSrc}
                    handleClick={handleClick}
                >
                    <React.Fragment>
                        {viewWidth > 992
                            ? !!unreadMessageCount && (
                                  <Counter
                                      cssClass="header-badges"
                                      countNumber={unreadMessageCount}
                                  />
                              )
                            : !!totalCount && (
                                  <Counter
                                      cssClass="header-badges"
                                      countNumber={totalCount}
                                  />
                              )}
                        <UserDropdown {...userDropdownProps} />
                    </React.Fragment>
                </IconTitleItemLayout>
            );
        },
    },

    {
        metaData: {
            key: 'user-unauth',
            title: 'Sign In',
            imgSrc: '/v1/avatar_black_160_vtg7lw.svg',
            url: null,
            metricEvent: 'top-nav-me-click',
            position: 'bottom',
            className: 'user-unauth',
        },
        Component: React.memo(
            ({ metaData, isLoggedIn, handleMetricEvent, loginProps }) => {
                if (isLoggedIn) return null;

                const pageCtx = React.useContext(PageContext);

                const { modals, modalTrigger, closeModal } = pageCtx;

                const allModalsClosed = modals && modals.type === null;

                const handleClick = () => {
                    // if there's another modal open, close it
                    if (!allModalsClosed) closeModal();

                    // if the modal is closed and we show it, log metric
                    if (allModalsClosed) handleMetricEvent('top-nav-me-click');

                    // trigger modal
                    return modalTrigger('authModal', { ...loginProps });
                };

                return (
                    <IconTitleItemLayout
                        itemKey={metaData.key}
                        className={metaData.className}
                        url={metaData.url}
                        title={metaData.title}
                        imgSrc={metaData.imgSrc}
                        handleClick={handleClick}
                    />
                );
            }
        ),
    },

    {
        metaData: {
            key: 'vertical-line-divider',
            title: null,
            imgSrc: null,
            url: null,
            metricEvent: null,
            position: 'bottom',
            className: 'vertical-line-divider',
        },
        Component: ({ metaData }) => (
            <VerticalLine className={metaData.className} />
        ),
    },

    {
        metaData: {
            key: 'for-clients-right',
            title: 'For Clients',
            url: '/employers/database',
            imgSrc: '575995136/navbar/employer-w.svg',
            metricEvent: 'top-nav-for-clients-click',
            position: 'bottom',
            className: 'for-clients-right',
        },
        Component: ({
            metaData,
            handleMetricEvent,
            athorizedForEmployerNav,
        }) => {
            if (!athorizedForEmployerNav) {
                return null;
            }

            return (
                <IconTitleItemLayout
                    itemKey={metaData.key}
                    className={metaData.className}
                    url={'/employers/dashboard'}
                    title={metaData.title}
                    imgSrc={metaData.imgSrc}
                    handleClick={handleMetricEvent(metaData.metricEvent)}
                />
            );
        },
    },

    {
        metaData: {
            key: 'for-employers',
            title: 'For Employers',
            url: '/employers',
            imgSrc: '575995136/navbar/employer-w.svg',
            metricEvent: null,
            position: 'bottom',
            className: 'for-employers',
        },
        Component: ({
            metaData,
            handleMetricEvent,
            athorizedForEmployerNav,
        }) => {
            if (athorizedForEmployerNav) {
                return null;
            }

            return (
                <IconTitleItemLayout
                    itemKey={metaData.key}
                    className={metaData.className}
                    url={metaData.url}
                    title={metaData.title}
                    imgSrc={metaData.imgSrc}
                    handleClick={handleMetricEvent(metaData.metricEvent)}
                />
            );
        },
    },
];
